var React = require('react');

function Z3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Z3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"0 23.07 29 23.07 44.92 0 0 0 0 23.07","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"38.96 60.51 61.72 2.45 37 3.58 5.02 85.17 23.27 84.33 29.74 84.03 68.14 82.27 67.08 59.22 38.96 60.51","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Z3.defaultProps = {"viewBox":"0 0 68.14 85.17"};

module.exports = Z3;

Z3.default = Z3;
